<ft-loading *ngIf="!initialized"></ft-loading>
<div ftFormColor ftBackgroundImage class="mainContent background-color-holder" *ngIf="initialized">
    <ft-main-template [params]="params" *ngIf="renderForm"></ft-main-template>
</div>
